import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Hint} from 'components/ui-kit/Hint';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors} from 'theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const CustomTitle = styled(Title)`
    color: #59606a;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 40px;
`;

export const FormFields = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    justify-content: flex-end;
`;

export const SubmitButton = styled(Button)`
    max-width: 240px;
`;

export const BackButton = styled(Button)`
    max-width: 240px;
    color: ${colors.textPrimary};
    text-decoration: none;
`;
